//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from "../../lib/util";
import { getRoomsByMemberId } from "../../api/newOwner";

export default {
    name: "delivery",
    data() {
        return {
            memberInfo: {},
            palnInfo: {
                steps: []
            },
            planId: 0,
            files: [],
            imgUrl: util.ApiUrl + 'file/download/',
            active: 0,
            roomList: [],
            activeNames: ['1'],
            stepTypeList: [
                { key: "提交资料", value: "10" },
                { key: "业户信息签名", value: "20" },
                { key: "预约交房时间", value: "30" },
                { key: "房屋交付文件确认", value: "40" },
            ]
        };
    },
    computed: {
        images() {
            let arr = []
            for (let i = 0; i < this.files.length; i++) {
                let item = this.files[i];
                let url = this.imgUrl + item.fileId;
                arr.push(url);
            }
            return arr;
        }
    },
    methods: {
        getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.memberInfo = {}
            abp.ajax.get('/api/services/app/Member/GetMyMember').then(res => {
                this.memberInfo = res.data.result;
                if (this.memberInfo.isAuthentication) {
                    this.active = 1;
                } else {
                    this.active = 0
                }
                this.getRoomsByMemberId();
            }).finally(() => {
                this.$toast.clear();
            });
        },
        getPlan() {
            abp.ajax.get('/api/services/app/Delivery/GetDeliveryPlanById?id=' + this.planId).then(res => {
                this.palnInfo = res.data.result;
                if (!this.palnInfo.steps) {
                    this.palnInfo.steps = []
                }
                util.title(this.palnInfo.name)
            }).finally(() => {

            })
        },
        getFiles() {
            let page = {
                associateId: this.planId,
                associateType: 'DeliveryPlanFile'
            }
            abp.ajax.get('/files', { params: page }).then(res => {
                this.files.push(...res.data.result.items)
            })
        },
        onCert() {
            localStorage.setItem('PlanId', this.planId)
            this.$router.push({ name: 'delivery-owner', params: { deliveryPlanId: this.planId } })
        },
        onUploadData(roomId, step) {
            let page = {
                planId: this.planId,
                roomId: roomId,
                // step: step
            }
            abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordByRoom', { params: page }).then(res => {
                this.$router.push({
                    name: 'delivery-data',
                    params: { roomId: roomId, deliveryPlanId: this.planId, step: step }
                })
            })
        },
        getRoomsByMemberId() {
            let page = {
                memberId: this.memberInfo.id, planId: this.planId
            }
            abp.ajax.get('/api/services/app/Delivery/GetDeliveryRooms', { params: page }).then(res => {
                this.roomList = [];
                this.roomList.push(...res.data.result);
            }).finally(() => {
            });
        },

        onAppointment(recordId) {
            this.$router.push({ name: 'delivery-appointment', params: { recordId: recordId } })
        },

        onReceiveConfirmation(recordId) {
            this.$router.push({ name: 'deliveryReceiveConfirmation', params: { recordId: recordId } })
        },

        onReceiveConfirmation2(roomId) {
            let page = {
                planId: this.planId,
                roomId: roomId,
            }
            abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordByRoom', { params: page }).then(res => {
                this.$router.push({ name: 'deliveryReceiveConfirmation', params: { recordId: res.data.result.id } })
            })
        },
    },
    created() {
        this.getMyMember();
        this.planId = parseInt(this.$route.params.id) || 0;
        if (this.planId > 0) {
            this.getPlan()
            this.getFiles()
        }
    },
    activated() {

    }
}
